import type {SyncRun} from '../api'

const DEFAULT_DURATION_MS = 5 * 60 * 1000
const HISTORY_LIMIT = 5

export function estimateSyncDuration(runs: SyncRun[]) {
  const durations = [...runs]
    .filter((run) => run.status === 'OK' && run.fim_em)
    .sort((a, b) => b.id - a.id)
    .map((run) => Date.parse(run.fim_em!) - Date.parse(run.iniciado_em))
    .filter((duration) => Number.isFinite(duration) && duration > 0)
    .slice(0, HISTORY_LIMIT)

  // As execuções mais recentes refletem melhor o volume e a velocidade atuais.
  const weight = durations.reduce((total, _, index) => total + durations.length - index, 0)
  const durationMs = weight
    ? durations.reduce(
        (total, duration, index) => total + duration * (durations.length - index),
        0
      ) / weight
    : DEFAULT_DURATION_MS

  return {durationMs, sampleCount: durations.length}
}

export function persistedSyncEstimate(run?: SyncRun) {
  const durationMs = Number(run?.estimativa_ms)
  if (!Number.isFinite(durationMs) || durationMs <= 0) return null
  const count = Number(run?.estimativa_amostras)
  const sampleCount = Number.isInteger(count) && count >= 0 && count <= HISTORY_LIMIT ? count : 0
  return {durationMs, sampleCount}
}

export function estimatedSyncProgress(elapsedMs: number, durationMs: number): number {
  const fraction = Math.min(1, Math.max(0, elapsedMs / durationMs))
  // A inclinação diminui continuamente até a estimativa. Só o servidor confirma 100%.
  return 99 * (1 - Math.pow(1 - fraction, 2))
}

export function formatSyncDuration(durationMs: number): string {
  const seconds = Math.max(0, Math.ceil(durationMs / 1000))
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60
  if (hours) return `${hours} h${minutes ? ` ${minutes} min` : ''}`
  if (minutes) return `${minutes} min${remainingSeconds ? ` ${remainingSeconds} s` : ''}`
  return `${seconds} s`
}
